
import Vue from 'vue'

// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
    // popup
    Popup,
    Toast,
    Dialog,
} from 'cube-ui'

Vue.use(Popup)
Vue.use(Toast)
Vue.use(Dialog)
let msssage = {
    popup: function (content,time) {
        let timeout=2000;
        if(time){
            timeout=time;
        }
        var pop= Popup.$create({ content }).show();
        setTimeout(() => {
            pop.hide();
          }, timeout)
    },
    toast: function (txt, time, callback) {
        if (!time) { time = 1000 };
        return Toast.$create({
            txt,
            mask:true,
            time: time,
            onTimeout: () => {
                if(typeof callback=='function'&&callback){
                    callback();
                }
            }
        }
        ).show();
    },
    confirm: function (title = "提示", content,callOk,callcancel) {
        return Dialog.$create({
            type: 'confirm',
            icon: 'cubeic-alert',
            title: title,
            content: content,
            confirmBtn: {
                text: '确定',
                active: true,
                disabled: false,
                href: 'javascript:;'
            },
            cancelBtn: {
                text: '取消',
                active: false,
                disabled: false,
                href: 'javascript:;'
            },
            onConfirm: () => {
                if(typeof callOk == 'function'&&callOk){
                    callOk();
                }
            },
            onCancel: () => {
                if(typeof callcancel == 'function'&&callcancel){
                    callcancel();
                }
            }
        }).show();
    }
}

export default msssage